import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import { Cta } from "../../blocks";
import Accordion from "../../components/accordion";
import BodyControl from "../../components/body";
import { convertKataToRome } from "../../utils";

/**
 *  SpecComparison
 */
class SpecComparison extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    description: PropTypes.string,
    mbDescription: PropTypes.string,
    compareGrades: PropTypes.arrayOf(PropTypes.shape(
      {
        modelName: PropTypes.string,
        carId: PropTypes.string,
        carTypeCode: PropTypes.string,
        gradeId: PropTypes.string,
        gradeCode: PropTypes.string,
        gradeName: PropTypes.string,
        specialCar: PropTypes.bool,
        variants: PropTypes.arrayOf(PropTypes.shape(
          {
            variantId: PropTypes.string,
            drive: PropTypes.string,
            transmission: PropTypes.string,
            price: PropTypes.number,
            specs: PropTypes.arrayOf(PropTypes.shape(
              {
                category: PropTypes.string,
                name: PropTypes.string,
                value: PropTypes.arrayOf(PropTypes.string),
                unit: PropTypes.string,
                description: PropTypes.string,
                seatImageSrc: PropTypes.string,
              },
            )),
          },
        )),
      },
    )),
    notice: PropTypes.string,
    cta: PropTypes.arrayOf(PropTypes.node),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    description: null,
    mbDescription: null,
    compareGrades: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    const defaultVariantInfo = this.getDefaultVariantInfo();
    //
    this.state = {
      currentCarId: (this.props.compareGrades[0] && this.props.compareGrades[0].carId) ? this.props.compareGrades[0].carId : null,
      currentCarTypeCode: (this.props.compareGrades[0] && this.props.compareGrades[0].carTypeCode) ? this.props.compareGrades[0].carTypeCode : null,
      currentGradeId: (this.props.compareGrades[0] && this.props.compareGrades[0].gradeId) ? this.props.compareGrades[0].gradeId : null,
      currentGradeCode: (this.props.compareGrades[0] && this.props.compareGrades[0].gradeCode) ? this.props.compareGrades[0].gradeCode : null,
      currentDrive: defaultVariantInfo.drive,
      currentTransmission: defaultVariantInfo.transmission,
      // currentDrive: this.props.compareGrades[0].variants[0].drive,
      // currentTransmission: this.props.compareGrades[0].variants[0].transmission,
      //openAccordion: true,
      //
      openAccordion: false,
      isMounted: false,
      openPulldown: false,
      fixed: false,
      subNavigationHeight: null,
    };
    this.subNavigationHeight = null;
    this.navigationTop = null;
    this.navigationHeight = null;
    this.specTop = null;
    this.specHeight = null;
    this.intervalId = null;
    this.accordionRefs = [];
    this.isCurrent = false;
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
    });
    //
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    //
    if (this.intervalId) clearTimeout(this.intervalId);
    this.intervalId = setInterval(() => {
      this.specHeight = this.refs.spec.getBoundingClientRect().height;
      this.handleScroll();
      this.handleResize();
    }, 500);

  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  componentWillUpdate(nextProps) {
    // GTMイベント
    if (nextProps.isCurrent !== this.isCurrent) {
      this.isCurrent = nextProps.isCurrent;
      if (nextProps.isCurrent) {
        BodyControl.setGTMEvent({
          trackvariant: this.state.currentDrive + '(' + this.state.currentTransmission + ')',
          event: 'SpecComparisonSelect',
        });
      }
    }
  }

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
    //
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    //
    if (this.intervalId) clearTimeout(this.intervalId);
  }

  render() {

    // グレード情報取得
    const getGradeInfo = (gradeId) => {
      let i, max;
      for (i = 0, max = this.props.compareGrades.length; i < max; i = i + 1) {
        const compareGrade = this.props.compareGrades[i];
        if (compareGrade.gradeId === gradeId) {
          return compareGrade;
        }
      }
      return null;
    };

    // 機種情報取得
    const getVariantInfo = (gradeId, drive, transmission) => {
      const gradeInfo = getGradeInfo(gradeId);
      let i, max;
      for (i = 0, max = gradeInfo.variants.length; i < max; i = i + 1) {
        const variant = gradeInfo.variants[i];
        if (variant.drive === drive && variant.transmission === transmission) {
          return variant;
        }
      }
      return null;
    };

    // マスタースペックカテゴリ取得
    const __getMasterSpecCategory = (drive, transmission) => {

      // 比較している全ての機種の情報を取得
      const _getVariantsInfo = () => {
        let variants = [];
        this.props.compareGrades.map((compareGrade, index) => {
          variants.push(getVariantInfo(compareGrade.gradeId, drive, transmission));
        });
        return variants;
      };

      // カテゴリー一覧取得
      const _getCategories = (variantsInfo) => {
        let categories = [];
        let i, max;
        for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
          const variantInfo = variantsInfo[i];
          if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
            let i, max;
            for (i = 0, max = variantInfo.specs.length; i < max; i = i + 1) {
              categories.push(variantInfo.specs[i].category);
            }
          }
        }

        // 配列から重複している値を削除
        categories = ((arr) => {
          return arr.filter((val, i, self) => {
            return self.indexOf(val) === i;
          });
        })(categories);

        // 値が存在しているカテゴリのみ抽出
        let arr = [];
        for (i = 0, max = categories.length; i < max; i = i + 1) {
          const isExistUnit = ((category) => {
            let i, max;
            for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
              const variantInfo = variantsInfo[i];
              if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
                let j, max2;
                for (j = 0, max2 = variantInfo.specs.length; j < max2; j = j + 1) {
                  const spec = variantInfo.specs[j];
                  if (spec.category === category && spec.unit !== 'blank') {
                    return true;
                  }
                }
              }
            }
            return false;
          })(categories[i]);
          if (isExistUnit) {
            arr.push(categories[i]);
          }
        }
        categories = arr;

        return categories;
      };

      // カテゴリーのスペック情報を取得
      const _getSpecsInfo = (variantsInfo, category) => {
        let arr = [];
        let i, max;
        for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
          const variantInfo = variantsInfo[i];
          let j, max2;
          for (j = 0, max2 = variantInfo.specs.length; j < max2; j = j + 1) {
            const spec = variantInfo.specs[j];
            if (spec.category === category) {
              // 重複しているかチェック
              let flg = true;
              let k, max3;
              for (k = 0, max3 = arr.length; k < max3; k = k + 1) {
                if ((arr[k].name || '') === (spec.name || '') && (arr[k].description || '') === (spec.description || '')) {
                  flg = false;
                  break;
                }
              }
              // 重複していなければ追加
              if (flg === true && spec.unit !== 'blank') {
                arr.push({
                  name: spec.name || null,
                  description: spec.description || null,
                });
              }
            }
          }
        }
        return arr;
      };

      // 比較している全ての機種の情報を取得
      const variantsInfo = _getVariantsInfo();

      // カテゴリー一覧取得
      const categoryArr = _getCategories(variantsInfo);

      // カテゴリー一覧を元に全てのスペック情報を取得
      let masterSpecCategory = [];
      let i, max;
      for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
        masterSpecCategory.push({
          category: categoryArr[i],
          specs: _getSpecsInfo(variantsInfo, categoryArr[i]),
        });
      }

      return masterSpecCategory;
    };

    // マスタースペックカテゴリ取得
    const _getMasterSpecCategory = (drive, transmission) => {

      const removeDuplicateValue = (arr) => {
        return arr.filter((val, i, self) => {
          return self.indexOf(val) === i;
        });
      };

      // カテゴリー一覧
      let categoryArr = [];
      this.props.compareGrades.map((compareGrade, index) => {
        const variantInfo = getVariantInfo(compareGrade.gradeId, drive, transmission);
        if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
          let i, max;
          for (i = 0, max = variantInfo.specs.length; i < max; i = i + 1) {
            if (variantInfo.specs[i].unit !== 'blank') {
              categoryArr.push(variantInfo.specs[i].category);
            }
          }
        }
      });
      categoryArr = removeDuplicateValue(categoryArr);

      // カテゴリー一覧を元に全てのスペック情報を取得
      let masterSpecCategory = [];

      //
      let i, max;
      for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
        let category = categoryArr[i];
        let arr = [];

        //
        this.props.compareGrades.map((compareGrade, index) => {
          const variantInfo = getVariantInfo(compareGrade.gradeId, drive, transmission);
          if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {

            //
            let i, max;
            for (i = 0, max = variantInfo.specs.length; i < max; i = i + 1) {
              let specs = variantInfo.specs[i];
              if (specs.category === category) {

                // 重複しているかチェック
                let flg = true;
                let j, max2;
                for (j = 0, max2 = arr.length; j < max2; j = j + 1) {
                  if ((arr[j].name || '') === (specs.name || '') && (arr[j].description || '') === (specs.description || '')) {
                    flg = false;
                    break;
                  }
                }

                // 重複していなければ追加
                if (flg === true && specs.unit !== 'blank') {
                  arr.push({
                    name: specs.name || null,
                    description: specs.description || null,
                  });
                }

              }
            }

          }
        });

        masterSpecCategory.push({
          category: categoryArr[i],
          specs: arr,
        });

      }

      return masterSpecCategory;
    };

    // マスタースペックカテゴリ取得
    const getMasterSpecCategory = (drive, transmission) => {
      if (window.MZD_SPEC_DATA_CATEGORY_LIST) {
        return window.MZD_SPEC_DATA_CATEGORY_LIST;
      } else {
        return _getMasterSpecCategory(drive, transmission);
      }
    };

    // スペック情報取得
    const getSpecInfo = (gradeId, drive, transmission) => {

      const removeDuplicateValue = (arr) => {
        return arr.filter((val, i, self) => {
          return self.indexOf(val) === i;
        });
      };

      const variantInfo = getVariantInfo(gradeId, drive, transmission);
      if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
        // フォーマット
        let categoryArr = [];
        let i, max;
        for (i = 0, max = variantInfo.specs.length; i < max; i = i + 1) {
          categoryArr.push(variantInfo.specs[i].category);
        }
        categoryArr = removeDuplicateValue(categoryArr);
        //
        let specs = [];
        for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
          const category = categoryArr[i];
          let obj = {
            category: category,
            specs: [],
          };
          let j, max2;
          for (j = 0, max2 = variantInfo.specs.length; j < max2; j = j + 1) {
            const spec = variantInfo.specs[j];
            if (category === spec.category) {
              obj.specs.push({
                name: spec.name || null,
                value: spec.value || null,
                unit: spec.unit || null,
                description: spec.description || null,
                seatImageSrc: spec.seatImageSrc || null,
              })
            }
          }
          specs.push(obj);
        }
        return specs;
      } else {
        return null;
      }
    };

    // 機種スペックデータからnameが一致するデータを取得
    const getVariantSpec = (variantSpecs, category, name, description) => {
      if (variantSpecs && 1 <= variantSpecs.length) {
        let i, max;
        for (i = 0, max = variantSpecs.length; i < max; i = i + 1) {
          if (variantSpecs[i].category === category) {
            let j, max2;
            for (j = 0, max2 = variantSpecs[i].specs.length; j < max2; j = j + 1) {
              if (variantSpecs[i].specs[j].name === name && (variantSpecs[i].specs[j].description || '') === (description || '')) {
                return variantSpecs[i].specs[j];
              }
            }
          }
        }
      } else {
        return null;
      }
    };

    // スペックが存在するか
    const getIsExistSpecValue = (drive, transmission, category, name, description) => {
      let i, max;
      for (i = 0, max = this.props.compareGrades.length; i < max; i = i + 1) {
        const compareGrade = this.props.compareGrades[i];
        const specInfo = getSpecInfo(compareGrade.gradeId, drive, transmission);
        let j, max2;
        if (specInfo) {
          for (j = 0, max2 = specInfo.length; j < max2; j = j + 1) {
            if (category === specInfo[j].category) {
              let k, max3;
              for (k = 0, max3 = specInfo[j].specs.length; k < max3; k = k + 1) {
                const spec = specInfo[j].specs[k];
                if (name === spec.name && description === spec.description) {
                  if (spec.unit && spec.unit !== '' && spec.unit !== 'blank') {
                    return true
                  } else {
                    if (spec.value && spec.value[0] && spec.value[0] !== '') {
                      return true
                    }
                  }
                }
              }
            }
          }
        }
      }
      return false;
    };

    // ------ Render ----- //

    // タイトル表示
    const renderDescription = () => {

      const getDescription = () => {
        if (this.props.description && this.props.description !== '') {
          return this.props.description;
        } else {
          return null;
        }
      };

      const getMbDescription = () => {
        if (this.props.mbDescription && this.props.mbDescription !== '') {
          return this.props.mbDescription;
        } else {
          return getDescription();
        }
      };

      const description = getDescription();
      const mbDescription = getMbDescription();

      if (description || mbDescription) {
        return (
          <div className="SpecComparison__description Wysiwyg">
            <span className="SpecComparison__description-pc"
              dangerouslySetInnerHTML={{ __html: (description !== null) ? description : '' }} />
            <span className="SpecComparison__description-mb"
              dangerouslySetInnerHTML={{ __html: (mbDescription !== null) ? mbDescription : '' }} />
          </div>
        )
      } else {
        return null;
      }

    };

    // ナビ表示
    const renderNavigation = () => {

      // 車種比較リンク
      const getModelComparisonHref = () => {
        let href = '/purchase/compare/';
        let params = '';
        params = params + '?car_id1=' + encodeURIComponent(this.state.currentCarId);
        params = params + '&car_type_code1=' + encodeURIComponent(this.state.currentCarTypeCode);
        params = params + '&grade1=' + encodeURIComponent(this.state.currentGradeId);
        if (this.props.compareGrades[1]) {
          params += (this.props.compareGrades[1].carId) ? '&car_id2=' + encodeURIComponent(this.props.compareGrades[1].carId) : '';
          params += (this.props.compareGrades[1].carTypeCode) ? '&car_type_code2=' + encodeURIComponent(this.props.compareGrades[1].carTypeCode) : '';
          params += (this.props.compareGrades[1].gradeId) ? '&grade2=' + encodeURIComponent(this.props.compareGrades[1].gradeId) : '';
        }
        if (this.props.compareGrades[2]) {
          params += (this.props.compareGrades[2].carId) ? '&car_id3=' + encodeURIComponent(this.props.compareGrades[2].carId) : '';
          params += (this.props.compareGrades[2].carTypeCode) ? '&car_type_code3=' + encodeURIComponent(this.props.compareGrades[2].carTypeCode) : '';
          params += (this.props.compareGrades[2].gradeId) ? '&grade3=' + encodeURIComponent(this.props.compareGrades[2].gradeId) : '';
        }
        return href + params;
      };

      // ------ Render ----- //

      // 比較軸グレード表示
      const renderMainVariant = (gradeId) => {

        // MBでのプルダウンアイテム表示
        const renderPulldown = () => {
          return (
            <div className="SpecComparison__pulldown">
              <a
                className={'SpecComparison__pulldown__link-variant' + ((this.state.openPulldown === true) ? ' open' : '')}
                href="javascript:void(0);"
                onClick={(e) => {
                  e.preventDefault();
                  if (this.state.openPulldown === true) {
                    this.setState({
                      openPulldown: false,
                    })
                  } else {
                    this.setState({
                      openPulldown: true,
                    })
                  }
                }}
              >
                {(currentVariantInfo && currentVariantInfo.drive && currentVariantInfo.transmission) ? currentVariantInfo.drive + ' ' + currentVariantInfo.transmission : ''}
              </a>
              <div
                className={'SpecComparison__pulldown__container' + ((this.state.openPulldown === true) ? ' open' : '')}>
                <div className="SpecComparison__pulldown__box">
                  <a className="SpecComparison__pulldown__link-close"
                    href="javascript:void(0);"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        openPulldown: false,
                      })
                    }}
                  >CLOSE</a>
                  <ul className="SpecComparison__pulldown__list">
                    {gradeInfo.variants.map((variant, index) => {
                      const variantInfo = getVariantInfo(gradeId, variant.drive, variant.transmission);
                      if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
                        return (
                          <li key={index}>
                            <a
                              className={'SpecComparison__pulldown__link-item' + ((this.state.currentDrive === variantInfo.drive && this.state.currentTransmission === variantInfo.transmission) ? ' current' : '')}
                              href="javascript:void(0);"
                              onClick={(e) => {
                                e.preventDefault();
                                // 機種変更
                                this.changeVariant(variantInfo.drive, variantInfo.transmission);
                                this.setState({
                                  openPulldown: false,
                                });

                                // GTMイベント
                                BodyControl.setGTMEvent({
                                  trackvariant: variantInfo.drive + '(' + variantInfo.transmission + ')',
                                  event: 'SpecComparisonSelect',
                                });

                              }}
                            >
                              {variantInfo.drive + ' ' + variantInfo.transmission}
                            </a>
                          </li>
                        )
                      } else {
                        return null;
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          )
        };

        // PCでのセレクター表示
        const renderSelect = () => {
          return (
            <form name='SpecComparisonForm'>
              <select
                className="SpecComparison__navigation__select"
                name={gradeInfo.gradeId}
                value={(currentVariantInfo && currentVariantInfo.drive && currentVariantInfo.transmission) ? currentVariantInfo.drive + ',' + currentVariantInfo.transmission : ''}
                onChange={(e) => {
                  //const gradeId = e.currentTarget.getAttribute('name');
                  //const arr = document.forms.SpecComparisonForm[gradeId].value.split(',');
                  const arr = e.currentTarget.value.split(',');
                  // 機種変更
                  if (arr && (arr[0] && arr[0] !== '') && (arr[1] && arr[1] !== '')) {
                    this.changeVariant(arr[0], arr[1]);
                  }

                  // GTMイベント
                  BodyControl.setGTMEvent({
                    trackvariant: arr[0] + '(' + arr[1] + ')',
                    event: 'SpecComparisonSelect',
                  });

                }}
              >
                {gradeInfo.variants.map((variant, index) => {
                  const variantInfo = getVariantInfo(gradeId, variant.drive, variant.transmission);
                  if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
                    return (
                      <option key={index} value={variantInfo.drive + ',' + variantInfo.transmission}>
                        {variantInfo.drive + ' ' + variantInfo.transmission}
                      </option>
                    )
                  } else {
                    return null;
                  }
                })}
              </select>
            </form>
          )
        };

        const gradeInfo = getGradeInfo(gradeId);
        const getGradeName = (gradeInfo) => {
          if (gradeInfo.specialCar === true) {
            return gradeInfo.gradeId;
          } else {
            return (gradeInfo.gradeName && gradeInfo.gradeName !== '') ? gradeInfo.gradeName : gradeInfo.gradeId;
          }
        };
        const currentVariantInfo = getVariantInfo(gradeId, this.state.currentDrive, this.state.currentTransmission);

        // console.log('----------');
        // console.log(gradeInfo);
        // console.log('gradeId: ' + gradeId);
        // console.log('currentDrive: ' + this.state.currentDrive);
        // console.log('currentTransmission: ' + this.state.currentTransmission);
        // console.log(currentVariantInfo);
        // console.log('----------');

        // 100th Anniversary Special Edition > 100周年特別記念車
        const convert100th = (text) => {
          if (text && text !== '') {
            text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
            text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
            text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
            text = text.replace('RF 35th SV', '35周年記念車');
            text = text.replace('35th SV', '35周年記念車');
            text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
            text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
            text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
            text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
            text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
            text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
            text = text.replace('15 BD i Selection II Black', '15 BD i Selection II インパネ：グロスブラック');
            text = text.replace('15 BD i Selection II Light Blue', '15 BD i Selection II インパネ：グロスライトブルー');
            text = text.replace('15 BD i Selection II White', '15 BD i Selection II インパネ：ピュアホワイト');
            text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
            text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
            text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
            text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
            text = text.replace('15 SPORT Plus', '15 SPORT＋');
            text = text.replace('XD SPORT Plus', 'XD SPORT＋');
            return text;
          } else {
            return text;
          }
        };

        if (gradeInfo) {
          return (
            <div>
              <p className="SpecComparison__navigation__grade">
                {/*{(gradeInfo.gradeName && gradeInfo.gradeName !== '') ? gradeInfo.gradeName : gradeInfo.gradeId}*/}
                {convert100th(getGradeName(gradeInfo))}
                {/*{getGradeName(gradeInfo)}*/}
              </p>
              {renderPulldown()}
              {renderSelect()}
              {(currentVariantInfo && 0 < currentVariantInfo.price) ? <p
                className="SpecComparison__navigation__price">{this.formatPrice(currentVariantInfo.price)}<span>(消費税込)</span>
              </p> : <p className="SpecComparison__navigation__price"></p>}
            </div>
          )
        } else {
          return null
        }
      };

      // 比較対象グレード表示
      const renderSubVariant = (gradeId, gradeName, specialCar, drive, transmission) => {
        const getGradeName = () => {
          if (specialCar === true) {
            return gradeId;
          } else {
            return (gradeName && gradeName !== '') ? gradeName : gradeId;
          }
        };
        const variantInfo = getVariantInfo(gradeId, drive, transmission);

        // 100th Anniversary Special Edition > 100周年特別記念車
        const convert100th = (text) => {
          if (text && text !== '') {
            text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
            text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
            text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
            text = text.replace('RF 35th SV', '35周年記念車');
            text = text.replace('35th SV', '35周年記念車');
            text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
            text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
            text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
            text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
            text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
            text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
            text = text.replace('15 BD i Selection II Black', '15 BD i Selection II インパネ：グロスブラック');
            text = text.replace('15 BD i Selection II Light Blue', '15 BD i Selection II インパネ：グロスライトブルー');
            text = text.replace('15 BD i Selection II White', '15 BD i Selection II インパネ：ピュアホワイト');
            text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
            text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
            text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
            text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
            text = text.replace('15 SPORT Plus', '15 SPORT＋');
            text = text.replace('XD SPORT Plus', 'XD SPORT＋');
            return text;
          } else {
            return text;
          }
        };

        if (variantInfo) {
          return (
            <div>
              <p className="SpecComparison__navigation__grade">{convert100th(getGradeName())}</p>
              {/*<p className="SpecComparison__navigation__grade">{getGradeName()}</p>*/}
              <p
                className="SpecComparison__navigation__variant">{variantInfo.drive + ' ' + variantInfo.transmission}</p>
              {(0 < variantInfo.price) ?
                <p className="SpecComparison__navigation__price">{this.formatPrice(variantInfo.price)}<span>(消費税込)</span>
                </p> : <p className="SpecComparison__navigation__price"></p>}
              {/*<p className="SpecComparison__navigation__price">{(0 < variantInfo.price) ? this.formatPrice(variantInfo.price) + '(税込)': null}</p>*/}
            </div>
          )
        } else {
          return (
            <div style={{ position: 'relative' }}>
              <p
                className="SpecComparison__navigation__grade">{(gradeName && gradeName !== '') ? convert100th(gradeName) : convert100th(gradeId)}</p>
              {/*<p className="SpecComparison__navigation__blank">該当する駆動・ミッションは<br/>存在しません</p>*/}
              <p className="SpecComparison__navigation__blank">指定された駆動・ミッションの<br />組合せは設定ありません</p>
              {/*<p className="SpecComparison__navigation__blank">指定の駆動・ミッションの<br/>組合せはありません</p>*/}
            </div>
            // <div>
            //   <p className="SpecComparison__navigation__grade">{(gradeName && gradeName !== '') ? gradeName : gradeId}</p>
            //   <p className="SpecComparison__navigation__variant"><span className="SpecComparison__blank">-</span></p>
            //   {/*<p className="SpecComparison__navigation__variant">{drive + ' ' + transmission}</p>*/}
            //   <p className="SpecComparison__navigation__price"><span className="SpecComparison__blank">-</span></p>
            // </div>
          );
        }
      };

      let count = 0;
      let count2 = 0;

      return (
        <div className="SpecComparison__navigation">
          <div className="SpecComparison__navigation__box">
            <Cta
              {...{
                ctaType: 'Free',
                href: getModelComparisonHref(),
                text: '他のグレード・車種で比較',
                targetBlank: false,
                linkType: 'Text-With-Icon',
                color: 'Dark',
                iconSrc: 'data:image/png;base64,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',
                //iconSrc: '/assets-dev/icon-next-black.png',
                additionalClass: 'SpecComparison__navigation__link-comparison',
              }}
            />
          </div>
          <div className="SpecComparison__navigation__box2" ref="navigation">
            <ul className="SpecComparison__navigation__list">
              <li />
              {this.props.compareGrades.map((compareGrade, index) => {
                count = count + 1;
                if (index <= 0) {
                  // 比較軸グレード
                  return (
                    <li key={index}>
                      {renderMainVariant(compareGrade.gradeId)}
                    </li>
                  )
                } else {
                  // 比較対象グレード表示
                  return (
                    <li key={index}>
                      {renderSubVariant(compareGrade.gradeId, compareGrade.gradeName, compareGrade.specialCar, this.state.currentDrive, this.state.currentTransmission)}
                    </li>
                  )
                }
              })}
              {(() => {
                if (count <= 2) {
                  return (
                    <li><span className="SpecComparison__blank">-</span></li>
                  )
                }
              })()}
            </ul>
          </div>
          <div className={'SpecComparison__navigation__box3' + ((this.state.fixed === true) ? ' open' : '')}
            style={{ 'top': this.state.subNavigationHeight }}>
            <ul className="SpecComparison__navigation__list">
              <li />
              {this.props.compareGrades.map((compareGrade, index) => {
                count2 = count2 + 1;
                if (index <= 0) {
                  // 比較軸グレード
                  return (
                    <li key={index}>
                      {renderMainVariant(compareGrade.gradeId)}
                    </li>
                  )
                } else {
                  // 比較対象グレード表示
                  return (
                    <li key={index}>
                      {renderSubVariant(compareGrade.gradeId, compareGrade.gradeName, compareGrade.specialCar, this.state.currentDrive, this.state.currentTransmission)}
                    </li>
                  )
                }
              })}
              {(() => {
                if (count2 <= 2) {
                  return (
                    <li><span className="SpecComparison__blank">-</span></li>
                  )
                }
              })()}
            </ul>
          </div>
        </div>
      )
    };

    // スペック表示
    const renderSpecs = () => {

      // ------ Render ----- //

      // スペックカテゴリ表示
      const renderSpecCategory = () => {
        // マスタースペックカテゴリ取得
        const masterSpecCategory = getMasterSpecCategory(this.state.currentDrive, this.state.currentTransmission);
        this.accordionRefs = [];
        return (
          masterSpecCategory.map((info, index) => {

            // スペックデータが有るか無しか
            let flg = false;
            let i, max;
            for (i = 0, max = info.specs.length; i < max; i = i + 1) {
              const spec = info.specs[i];
              if (getIsExistSpecValue(this.state.currentDrive, this.state.currentTransmission, info.category, spec.name, spec.description)) {
                flg = true;
              }
            }
            if (!flg) return null;


            this.accordionRefs.push('accordion' + index);
            const isOpen = (index <= 0) ? true : false;
            return (
              <Accordion
                ref={'accordion' + index}
                pageName={info.category}
                pcText={info.category}
                mbText={info.category}
                open={isOpen}
                // open={this.state.openAccordion}
                enabled={true}
                key={index}
              >
                <ul className="SpecComparison__spec__table">
                  {renderSpecName(info.category, info.specs)}
                </ul>
              </Accordion>
            )
          })
        )
      };

      // スペック名表示
      const renderSpecName = (category, masterSpecs) => {
        return (
          masterSpecs.map((masterSpec, index) => {

            // スペックデータが有るか無しか
            if (!getIsExistSpecValue(this.state.currentDrive, this.state.currentTransmission, category, masterSpec.name, masterSpec.description)) return null;

            let count = 0;
            return (
              <li className="SpecComparison__spec__table-row" key={index}>
                <div
                  className="SpecComparison__spec__table-cell">{masterSpec.name + ' ' + ((masterSpec.description) ? masterSpec.description : '')}</div>
                {this.props.compareGrades.map((compareGrade, index2) => {
                  count = count + 1;
                  const variantSpecs = getSpecInfo(compareGrade.gradeId, this.state.currentDrive, this.state.currentTransmission);
                  if (variantSpecs && 1 <= variantSpecs.length) {
                    const variantSpec = getVariantSpec(variantSpecs, category, masterSpec.name, masterSpec.description);
                    if (variantSpec) {
                      return (
                        <div className="SpecComparison__spec__table-cell"
                          key={index2}>{renderVariantsSpecValue(category, variantSpec, compareGrade)}</div>
                      )
                    } else {
                      return (
                        <div className="SpecComparison__spec__table-cell" key={index2}><span
                          className="SpecComparison__blank">-</span></div>
                      )
                    }
                  } else {
                    return (
                      <div className="SpecComparison__spec__table-cell" key={index2}><span
                        className="SpecComparison__blank">-</span></div>
                      // <div className="SpecComparison__spec__table-cell" key={index2}>該当する駆動・ミッションは<br/>存在しません</div>
                    )
                  }
                })}
                {(() => {
                  if (count <= 2) {
                    return (
                      <div className="SpecComparison__spec__table-cell"><span className="SpecComparison__blank">-</span>
                      </div>
                    )
                  }
                })()}
              </li>
            )
          })
        );
      };

      // 機種スペック値表示
      const renderVariantsSpecValue = (category, spec, compareGrade) => {

        // メディアディレクトリ取得
        const getMediaDirectory = () => {
          if (this.state.isMounted === false) return '/assets-dev/';
          if (0 <= String(location.hostname).indexOf('localhost')) {
            return '/assets-dev/';
          } else {
            return '/globalassets/';
          }
        };

        const formatSrc = (src) => {
          if (this.state.isMounted === false) return src;
          if (0 <= String(location.hostname).indexOf('localhost')) {
            return src;
          } else {
            return src.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
          }
        };

        if (category === 'シート' && spec.name === 'シート材質') {
          let directory = 'assets/cars/';
          directory = directory + compareGrade.modelName + '/';
          directory = directory + compareGrade.carId + '/';
          directory = directory + compareGrade.carTypeCode + '/';
          directory = directory + convertKataToRome(compareGrade.gradeId) + '/';
          directory = directory + 'seat/';
          directory = directory.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
          return (
            <div>
              {(this.state.isMounted === true && spec.unit) ? <img className="SpecComparison__spec__seat-image"
                src={formatSrc(getMediaDirectory() + directory + spec.unit + '.png')} /> : ''}
              {(spec.value) ? <p className="SpecComparison__spec__value">{spec.value.join(' | ')}</p> : ''}
            </div>
          )
        } else {
          return (
            <div>
              {(this.state.isMounted === true && spec.unit) ? <div><img className="SpecComparison__spec__unit-image"
                src={formatSrc(getMediaDirectory() + 'assets/home/common/icon/' + spec.unit + '.png')} />
              </div> : ''}
              {(spec.value) ? <p className="SpecComparison__spec__value">{spec.value.join(' | ')}</p> : ''}
            </div>
          )
        }
      };

      return (
        <div className="SpecComparison__spec">
          <div className="SpecComparison__spec__container">
            <div ref="spec">
              <div className="SpecComparison__spec__box">
                <a className={'SpecComparison__spec__link-open' + ((this.state.openAccordion) ? ' open' : '')}
                  href="javascript:void(0);"
                  onClick={(e) => {
                    e.preventDefault();
                    // アコーディオンを閉じる、開く
                    this.changeAccordionView();
                  }}
                >
                  <span className="SpecComparison__spec__link-open__open">すべて見る</span>
                  <span className="SpecComparison__spec__link-open__close">すべて閉じる</span>
                  <span className="SpecComparison__spec__link-open__icon" />
                  <span className="SpecComparison__spec__link-open__icon2" />
                </a>
              </div>
              {renderSpecCategory()}
            </div>
          </div>
          <ul className="SpecComparison__spec__list">
            <li>標準装備</li>
            <li>メーカーオプション</li>
            <li>設定無し</li>
          </ul>
        </div>
      )

    };

    // 注釈表示
    const renderNotice = () => {
      if (this.props.notice && this.props.notice !== '') {
        return (
          <div className="SpecComparison__notice Wysiwyg" dangerouslySetInnerHTML={{ __html: this.props.notice }} />
        )
      } else {
        return null;
      }
    };

    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <div className="SpecComparison">
          <div className="SpecComparison__container">
            {renderDescription()}
          </div>
          <div className="SpecComparison__container2">
            {renderNavigation()}
          </div>
          <div className="SpecComparison__container3">
            <div className="SpecComparison__fade-in-container open" ref="changeVariant">
              {renderSpecs()}
              {renderNotice()}
              {this.props.cta}
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }

  //
  handleResize = () => {
    const windowTop = window.pageYOffset;
    this.navigationTop = this.refs.navigation.getBoundingClientRect().top + windowTop;
    this.navigationHeight = this.refs.navigation.getBoundingClientRect().height;
    this.specTop = this.refs.spec.getBoundingClientRect().top + windowTop;
    this.specHeight = this.refs.spec.getBoundingClientRect().height;
    this.subNavigationHeight = BodyControl.getSubNavigationHeight();
    //
    this.setState({
      subNavigationHeight: this.subNavigationHeight,
    })
  };

  //
  handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if ((this.specTop + this.specHeight) - (this.subNavigationHeight + this.navigationHeight) <= scrollTop) {
      if (this.state.fixed === true) {
        this.setState({
          fixed: false,
        });
      }
    } else {
      if (this.navigationTop <= (this.subNavigationHeight + scrollTop)) {
        if (this.state.fixed === false) {
          this.setState({
            fixed: true,
          });
        }
      } else {
        if (this.state.fixed === true) {
          this.setState({
            fixed: false,
          });
        }
      }
    }
  };

  // 機種変更
  changeVariant = (drive, transmission) => {
    this.setState({
      openAccordion: false,
      currentDrive: drive,
      currentTransmission: transmission,
    });
    let i, max;
    for (i = 0, max = this.accordionRefs.length; i < max; i = i + 1) {
      if (i <= 0) {
        this.refs[this.accordionRefs[i]].open();
      } else {
        this.refs[this.accordionRefs[i]].close();
      }
    }
    if (this.state.openAccordion === true) {
      this.setState({
        openAccordion: false,
      })
    }
    // フェードインアニメーション
    this.refs.changeVariant.classList.remove('open');
    setTimeout(() => {
      this.refs.changeVariant.classList.add('open');
    }, 100);
  };

  // アコーディオンを閉じる、開く
  changeAccordionView = () => {
    if (this.state.openAccordion === true) {
      let i, max;
      for (i = 0, max = this.accordionRefs.length; i < max; i = i + 1) {
        this.refs[this.accordionRefs[i]].close();
      }
      this.setState({
        openAccordion: false,
      })
    } else {
      let i, max;
      for (i = 0, max = this.accordionRefs.length; i < max; i = i + 1) {
        this.refs[this.accordionRefs[i]].open();
      }
      this.setState({
        openAccordion: true,
      })
    }
  };

  // 金額フォーマット
  formatPrice = (num) => {
    return '¥' + String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  };

  // デフォルト機種情報取得
  getDefaultVariantInfo = () => {
    let i, max;
    for (i = 0, max = this.props.compareGrades[0].variants.length; i < max; i = i + 1) {
      const variant = this.props.compareGrades[0].variants[i];
      if (variant.default === true) {
        return variant;
      }
    }
    return this.props.compareGrades[0].variants[0];
  };

}

export default SpecComparison;



// WEBPACK FOOTER //
// ./src/containers/spec-comparison/index.jsx